module.exports = __webpack_public_path__ + "img/resultados.bf6fed19.png";